import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'antd';

export default function AssignmentsToUpdateList({ items }) {
  const columns = [
    {
      title: 'Team Member',
      dataIndex: 'teamMemberName',
      key: 'teamMemberName',
      render: (_, record) =>
        `${record.staffingRequestAssignment.worksProfile.fullName}`,
    },
    {
      title: 'Supplier',
      dataIndex: 'supplierName',
      key: 'supplierName',
      render: (_, record) =>
        `${record.staffingRequestAssignment.supplier.name}`,
    },
    {
      title: 'Unit',
      dataIndex: 'unit',
      render: (_, record) =>
        `${record.staffingRequestAssignment.organizationUnit.name}`,
    },
    {
      title: 'Facility',
      dataIndex: 'facility',
      render: (_, record) =>
        `${record.staffingRequestAssignment.organization.name} - ${record.staffingRequestAssignment.organizationUnit.department.organizationBusiness.name}`,
    },
  ];

  return (
    <>
      {items.length > 0 && (
        <Table
          className="item-template-list"
          dataSource={items}
          columns={columns}
        ></Table>
      )}
      <style jsx>{`
        :global(.item-template-list .ant-table .ant-table-tbody > tr > td) {
          padding: 20px 4px 20px 8px;
        }
      `}</style>
    </>
  );
}

AssignmentsToUpdateList.propTypes = {
  worksListTemplateId: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      staffingRequestAssignment: PropTypes.shape({
        worksProfile: PropTypes.shape({
          fullName: PropTypes.string.isRequired,
        }),
        supplier: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }),
        organizationUnit: PropTypes.shape({
          name: PropTypes.string.isRequired,
          department: PropTypes.shape({
            organizationBusiness: PropTypes.shape({
              name: PropTypes.string.isRequired,
            }),
          }),
        }),
        organization: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }),
      }),
    })
  ).isRequired,
};
